import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { SvgIconComponent } from '../../../../../shared/components/svg-icon/svg-icon.component';
import { SourceQuotaComponent } from '../source-quota/source-quota.component';
import { CDFILeadsQuota } from '../../models/CDFI-leads-quota';
import { SumPipe } from '../../../../../shared/pipes/sum.pipe';
import { SourceTypes } from '../../../../../shared/models/source-types';
import { PopupComponent } from '../../../../../shared/components/popup/popup.component';
import { CdfiLeadsQuotaService } from '../../services/cdfi-leads-quota.service';
import { DestroyBase } from '../../../../../shared/base-classes/destroy-component-base';
import { takeUntil } from 'rxjs';

@Component({
  selector: 'app-connection-quota',
  standalone: true,
  imports: [SvgIconComponent, SourceQuotaComponent, SumPipe, PopupComponent],
  templateUrl: './connection-quota.component.html',
  styleUrl: './connection-quota.component.scss',
})
export class ConnectionQuotaComponent extends DestroyBase {
  @Input({ required: true }) connectionQuota!: CDFILeadsQuota;
  @Input({ required: true }) sourceTypes!: SourceTypes[];

  @Output() deletedConnectionQuota = new EventEmitter<void>();
  @Output() updatedSourceQuotaDetails = new EventEmitter<void>();

  expandedCards = new Set<string>();
  showDeleteConfirmPopup = false;

  cdfiLeadsQuoataService = inject(CdfiLeadsQuotaService);

  toggleCard(connectionName: string): void {
    if (this.expandedCards.has(connectionName)) {
      this.expandedCards.delete(connectionName);
    } else {
      this.expandedCards.add(connectionName);
    }
  }

  isExpanded(connectionName: string): boolean {
    return this.expandedCards.has(connectionName);
  }

  deleteConnectionQuota(): void {
    const sourceTypes = this.connectionQuota.details.map(
      (detail) => detail.source_type,
    );
    this.cdfiLeadsQuoataService
      .deleteLeadsQuota(sourceTypes, this.connectionQuota.connection_id)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: () => {
          this.deletedConnectionQuota.emit();
          this.showDeleteConfirmPopup = false;
        },
        error: (err) => {
          console.error('Error deleting connection quota:', err);
          this.showDeleteConfirmPopup = false;
        },
      });
  }

  removedAllSourceQuota(): void {
    this.deletedConnectionQuota.emit();
  }

  UpdateInSourceQuotaDetails(): void {
    this.updatedSourceQuotaDetails.emit();
  }
}
